import { Box, Flex, BoxProps, FlexProps } from '@chakra-ui/react';
import { specialFont } from 'constants/theme';

type CollapsibleHalfProps = {
  title: string;
  subtitle: string | null | undefined;
  children: React.ReactNode;
  version?: number;
  titleProps?: BoxProps;
  subtitleProps?: FlexProps;
};

const CollapsibleHalf = ({ title, subtitle, children, titleProps, subtitleProps }: CollapsibleHalfProps) => (
  <Flex flexDir="column" alignItems="center" flex={1} w={300} h="full">
    <Box
      color="primaryThemeColour.400"
      justifyItems="flex-start"
      px={4}
      pt={2.5}
      fontSize="xl"
      letterSpacing={5}
      w="full"
      {...titleProps}
    >
      {title}
    </Box>
    <Flex
      color="primaryFontColour.500"
      px={2}
      fontSize={36}
      fontFamily={specialFont}
      justifyItems="flex-start"
      letterSpacing={5}
      textAlign="left"
      w="95%"
      mt={0}
      {...subtitleProps}
    >
      {subtitle}
    </Flex>
    {children}
  </Flex>
);

export default CollapsibleHalf;
